// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"02937290","353":"22f36c8a"}[chunkId] + ".js";
};